<template>
  <div id="home" class="view">
    <!-- SIDEMENU -->
    <div id="sidemenu">
      <transition name="fade">
        <div class="backdrop" v-if="showMenu" @click="closeMenu"></div>
      </transition>

      <transition name="menu-slide">
        <div class="wrapper" v-if="showMenu">
          <!-- 내정보 -->
          <div class="side-summary">
            <div class="logo">
              <img src="@/assets/icons/icon1.png" alt="" />
            </div>
            <ul class="amounts">
              <li class="i-amount month-amount">
                <div class="lab">월급</div>
                <div class="val">
                  {{ $filters.numberFormat(userInfo.monthAmount) }}
                </div>
              </li>
              <li class="i-amount use-amount">
                <div class="lab">지출</div>
                <div class="val">
                  {{ $filters.numberFormat(userInfo.useAmount) }}
                </div>
              </li>
            </ul>
          </div>
          <div class="edit-wrapper">
            <div class="inner" @click="edit">수정</div>
          </div>

          <ul class="menu-list">
            <li class="i-menu" @click="myPosition">
              <div class="item">나의 위치</div>
            </li>
            <li class="i-menu" @click="myAnalytics">
              <div class="item">통계</div>
            </li>
          </ul>
        </div>
      </transition>
    </div>

    <!-- SIDEMENU -->

    <!-- head -->
    <div class="header">
      <div class="i-header-btn" @click="openMenu">
        <i class="fas fa-bars"></i>
      </div>
    </div>

    <div class="content scroll">
      <!-- 내정보 -->
      <div class="summary">
        <div class="logo">
          <img src="@/assets/icons/icon1.png" alt="" />
        </div>
        <ul class="amounts">
          <li class="i-amount month-amount">
            <div class="lab">월급</div>
            <div class="val">
              {{ $filters.numberFormat(userInfo.monthAmount) }}
            </div>
          </li>
          <li class="i-amount use-amount">
            <div class="lab">지출</div>
            <div class="val">
              {{ $filters.numberFormat(userInfo.useAmount) }}
            </div>
          </li>
          <li class="i-amount remain-amount">
            <div class="lab">내 쌈짓돈</div>
            <div class="val">
              {{ $filters.numberFormat(userInfo.remainAmount) }}
            </div>
          </li>
        </ul>
      </div>
      <!-- 목록 -->
      <ul class="list">
        <UseItem
          v-for="item in mock.useList"
          @click="detail(item.id)"
          :key="item.id"
          :icon="item.icon"
          :bgColor="item.bgColor"
          :label="item.title"
          :amount="item.price"
        />
        <UseItemEmpty
          v-for="item in mock.defaultList"
          @click="make(item.name, item.icon)"
          :key="item.id"
          :icon="item.icon"
          :label="item.name"
        />
      </ul>
    </div>

    <div class="add-wrapper">
      <div class="i-btn" @click="make()">
        <i class="fas fa-plus"></i>
        <div class="txt">새 지출항목 만들기</div>
      </div>
    </div>
  </div>
</template>
<script>
import UseItem from "@/components/UseItem";
import UseItemEmpty from "@/components/UseItemEmpty";

export default {
  name: "Home",
  data() {
    return {
      showMenu: false,
      test: "2000",
      userInfo: {
        monthAmount: "2000000",
        useAmount: "1500000",
        remainAmount: "500000",
      },
      mock: {
        useList: [],
        defaultList: [],
      },
    };
  },
  components: {
    UseItem,
    UseItemEmpty,
  },
  methods: {
    detail(id) {
      this.$router.push("/use-detail/" + id);
    },
    openMenu() {
      console.log("open menu");
      this.showMenu = true;
    },
    closeMenu() {
      this.showMenu = false;
    },
    make(name, icon) {
      console.warn('n', name);
      if (name && name != "") {
        console.warn('1');
        var iconId = icon.split("icon")[1].split(".")[0];
        this.$router.push("/use-create/" + name + "/" + iconId);
      } else {
        console.warn('22');
        this.$router.push("/use-create");
      }
    },
    edit() {
      console.log("Edit!");
    },
    myPosition() {
      this.showMenu = false;
      this.$router.push("/my-position");
    },
    myAnalytics() {
      this.showMenu = false;
      this.$router.push("/my-analytics");
    },
  },
  created() {},
  mounted() {
    this.$api.userInfo({
      user_token: this.$user.getToken(),
    }).then((rs)=> {
      this.userInfo.monthAmount = Number(rs.info.salary);
      this.userInfo.useAmount = Number(rs.info.totalSpend);
      this.userInfo.remainAmount = Number(rs.info.ssamziMoney);
    })
    // this.$api.editProfile({
    //   user_token: this.$user.getToken(),
    //   salary: '2000000',
    // }).then((rs)=> {
    //   console.warn('User info', rs.info);
    // })

    this.$api
      .getUserSpend({
        user_token: this.$user.getToken(),
      })
      .then((rs) => {
        let useList = [];
        if (rs && rs.list.length > 0) {
          useList = rs.list;
        }
        this.$api
          .getRecommendList({
            user_token: this.$user.getToken(),
          })
          .then((rs) => {

            let defaultList = [];
            for (let defaultIdx in rs.list) {
              let hasOwn = false;
              let defaultItem = rs.list[defaultIdx];
              var defaultName = defaultItem.name;
              for (let useIdx in useList) {
                if (defaultName == useList[useIdx].title) {
                  hasOwn = true;
                  break;
                }
              }
              if (!hasOwn) {
                defaultList.push(defaultItem);
              }
            }
            this.mock.useList = useList;
            this.mock.defaultList = defaultList;
          });
      });
  },
};
</script>
<style scoped>
.add-wrapper {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 70px;
  background: #f8f8f8;
  border-radius: 25px 25px 0 0;
  z-index: 100;

  display: flex;
  align-items: center;
  justify-content: center;
}
.add-wrapper .i-btn {
  display: inline-block;
  padding: 0 16px;
  height: 50px;

  display: flex;
  align-items: center;
  justify-content: center;
}
.add-wrapper .i-btn i {
  font-size: 15px;
  margin-top: 3px;
  color: #0085ff;
}
.add-wrapper .i-btn .txt {
  margin-left: 7px;
  font-size: 17px;
  font-weight: 500;
  color: #a5a5a5;
}

.summary {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 24px;
  border-bottom: 1px solid #eaeaea;
}
.summary > .logo {
  min-width: 100px;
}
.summary > .logo img {
  width: 100%;
}

.summary > .amounts {
  margin-left: 16px;
  width: 100%;
}

.summary > .amounts .i-amount {
  height: 45px;

  display: flex;
  align-items: center;
  justify-content: center;

  color: #647878;
  font-size: 17px;
  font-weight: 900;
}
.summary > .amounts .i-amount .lab {
  display: inline-block;
  min-width: 85px;
  text-align: right;
}
.summary > .amounts .i-amount .val {
  display: inline-block;
  width: 100%;
  text-align: right;
}

.summary > .amounts .i-amount.remain-amount {
  font-size: 19px;
  height: 50px;
  color: #4f79f3;
}

.list {
  margin-top: 20px;
}

#sidemenu {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  pointer-events: none;
}
#sidemenu .backdrop {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  background: rgba(0, 0, 0, 0.5);
  pointer-events: all;
}
#sidemenu .wrapper {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 80%;
  z-index: 2;
  background: white;
  pointer-events: all;
}
#sidemenu .side-summary {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 24px;
  border-bottom: 1px solid #eaeaea;
}
#sidemenu .side-summary > .logo {
  min-width: 30px;
  width: 80px;
}
#sidemenu .side-summary > .logo img {
  width: 100%;
}

#sidemenu .side-summary > .amounts {
  margin-left: 16px;
  width: 100%;
}

#sidemenu .side-summary > .amounts .i-amount {
  height: 45px;

  display: flex;
  align-items: center;
  justify-content: center;

  color: #647878;
  font-size: 17px;
  font-weight: 900;
}
#sidemenu .side-summary > .amounts .i-amount .lab {
  display: inline-block;
  min-width: 40%;
  text-align: right;
}
#sidemenu .side-summary > .amounts .i-amount .val {
  display: inline-block;
  width: 100%;
  text-align: right;
}

#sidemenu .side-summary > .amounts .i-amount.remain-amount {
  font-size: 25px;
  height: 50px;  
}
#sidemenu .edit-wrapper {
  padding: 5px 16px;
}
#sidemenu .edit-wrapper .inner {
  border-radius: 15px;
  border: 1px solid #ccc;
  height: 50px;

  display: flex;
  align-items: center;
  justify-content: center;

  color: black;
  font-size: 18px;
}
#sidemenu .menu-list {
  padding-top: 20px;
}
#sidemenu .menu-list .i-menu {
}
#sidemenu .menu-list .i-menu .item {
  height: 70px;
  padding: 0 24px;
  font-size: 20px;
  font-weight: 900;
  color: black;

  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.menu-slide-enter-active,
.menu-slide-leave-active {
  transition: transform 0.2s ease;
}

.menu-slide-enter-from,
.menu-slide-leave-to {
  /* opacity: 0; */
  transform: translateX(-100%);
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>